var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gender_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1158.3 1018.2"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 70
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#F9AF1C"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 289.5,
    cy: 289.5,
    r: 254.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M289.3 545.4v437.8M111.6 757.1h349.6"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#35A4DD"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 868.8,
    cy: 722.9,
    r: 254.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M867.1 99v369.9M862.1 96.9L676.4 282.5M868.6 96.9l185.6 185.6"
  })))));
}

export default SvgGender;